<template>
<div>
    <div>
        <Breadcrumbs main="" submain="My Workspace" title="My Updates" />

        <div class="container-fluid">
            <div class="" v-if="!loading && !error">
                <div class="card">
                    <div class="card-body">
                        <div class="col-md-12">
                            <div style="display: flex; justify-content: end;">
                               
                            </div>
                            <b-row class="d-flex flex-wrap justify-content-center align-items-center">
                                <b-col xl="7" class="d-flex flex-wrap" style="gap: 20px">
                                    
                                    <div class="" style="display:flex; align-items: center; justify-content: center; gap: 12px;">
                                        <span style="font-size: 16px; font-weight: 500;">Only show unread</span>
                                        <b-form-checkbox
                                                v-model="messageBool"
                                                name="check-button"
                                                switch
                                                size="lg"
                                                class="custom-switch"
                                                @change="toggleShowMessage"
                                              
                                                >
                                        </b-form-checkbox>
                                        
                                    </div>
                                  

                                     <!-- <div class="text-right media-body icon-state switch-outline">
                                                <label class="switch">
                                                    <input type="checkbox" :checked="messageBool" @click="toggleShowMessage()">
                                                    <span class="bg-primary switch-state">{{ readMessage }}</span>
                                                </label>
                                            </div> -->

                                    <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #563EE0; padding: 6px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="toggleFilterShow()">
                                        <feather type="filter"></feather>
                                        <h7>Filter</h7>
                                    </div>

                                    <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #DC3545; padding: 6px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="clearFilter()" v-if="filterShow || selectedCategory || start_date || end_date">
                                        <feather type="x"></feather>
                                        <h7>Clear All</h7>
                                    </div>
                                    
                                    <b-form-select v-model="perPage" :options="pageOptions" style="max-width: 120px;"></b-form-select>
                                  
                                </b-col>

                                <b-col xl="5" class="d-flex flex-column mt-3 mt-sm-0 align-items-sm-end" style="">
                                   
                                      <NotificationPermission/>
                                   
                                   
                                </b-col>
                            </b-row>

                            <div class="row mt-2" v-if="filterShow">
                                <div class="col-md-12">
                                    <div class="grid-container mt-sm-0">
                                        <div class="grid-item">
                                            <datepicker placeholder="Start Date" input-class="datepicker-here form-control digits" v-model="start_date"></datepicker>
                                        </div>
                                        <div class="grid-item">
                                            <datepicker placeholder="End Date" input-class="datepicker-here form-control digits" v-model="end_date"></datepicker>
                                        </div>
                                        <div class="grid-item">
                                            <b-form-select v-model="selectedCategory" :options="formattedOptions"></b-form-select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12" style="margin-top: 20px;">
                            <div v-if="updates_list.length">
                                <div class="card" v-for="(myUpdate) in updates_list" :key="myUpdate.id" :class="{ 'read': !myUpdate.read }">
                                    <div class="card-body" @click="readMsg(myUpdate)" style="cursor: pointer;">
                                        <div style="display: flex; flex-direction: row; justify-content: space-between">
                                            <div>
                                                <h7>{{ myUpdate.activity }}</h7>
                                            </div>
                                            <div>
                                                <span v-if="myUpdate.ref_type == 'LEAVE'">
                                                    <b-badge pill variant="danger">{{ myUpdate.ref_type}}</b-badge>
                                                </span>
                                                <span v-if="myUpdate.ref_type == 'TICKET'">
                                                    <b-badge pill variant="info">{{ myUpdate.ref_type}}</b-badge>
                                                </span>
                                                <span v-if="myUpdate.ref_type == 'BUDGET'">
                                                    <b-badge pill variant="warning">{{ myUpdate.ref_type}}</b-badge>
                                                </span>
                                                <span v-if="myUpdate.ref_type == 'GRIEVANCE'">
                                                    <b-badge pill variant="primary">{{ myUpdate.ref_type}}</b-badge>
                                                </span>
                                                <span v-if="myUpdate.ref_type == 'EOD'">
                                                    <b-badge pill variant="dark">{{ myUpdate.ref_type}}</b-badge>
                                                </span>
                                                <span v-if="myUpdate.ref_type == 'REQUISITION'">
                                                    <b-badge pill variant="secondary">{{ myUpdate.ref_type}}</b-badge>
                                                </span>

                                            </div>
                                        </div>
                                        <div>
                                            <h7>{{ updateTime(myUpdate.timestamp) }}</h7>

                                        </div>

                                    </div>
                                </div>

                                <b-row class="mt-3">
                                    <b-col xl="12" class="d-flex flex-wrap justify-content-start align-items-center" style="gap: 8px;">
                                        <span>
                                            <!-- First Page Button (<<) -->
                                            <button class="pg-button" :disabled="currentPage === 1" @click="goToPage(1)">
                                                <b-icon icon="chevron-double-left"></b-icon>
                                            </button>

                                            <!-- Previous Page Button (<) -->

                                            <button class="pg-button ml-2" :disabled="currentPage === 1" @click="goToPage(currentPage - 1)">
                                                <b-icon icon="chevron-left"></b-icon>
                                            </button>
                                        </span>

                                        <!-- Page Number Display (Page X of Y) -->
                                        <!-- <span class="align-self-center">
                                            <span class="align-self-center">
                                                <span class="d-flex align-items-center" style="gap: 6px;">
                                                    <span>Page</span>
                                                    <b-form-input v-model="currentPage" style="box-shadow: none; max-width: 40px;" @blur="validatePage" @keydown.enter="validatePage" :disabled="totalPages <= 1"></b-form-input>
                                                    <span>of {{ totalPages }}</span>
                                                </span>
                                            </span>
                                        </span> -->
                                        <span class="align-self-center">
                                            <span class="align-self-center">
                                                <span class="d-flex align-items-center" style="gap: 6px;">
                                                    <span>Page</span>
                                                    <b-form-input v-model="pageInput" style="box-shadow: none; max-width: 40px;" @input="handlePageInput" @blur="validatePage" @keydown.enter="validatePage" :disabled="totalPages <= 1" :max="totalPages"></b-form-input>
                                                    <span>of {{ totalPages }}</span>
                                                </span>
                                            </span>
                                        </span>

                                        <span>
                                            <!-- Next Page Button (>) -->
                                            <button class="mr-2 pg-button" :disabled="currentPage === totalPages" @click="goToPage(currentPage + 1)">
                                                <b-icon icon="chevron-right"></b-icon>
                                            </button>

                                            <!-- Last Page Button (>>) -->
                                            <button class="pg-button" :disabled="currentPage === totalPages" @click="goToPage(totalPages)">
                                                <b-icon icon="chevron-double-right"></b-icon>
                                            </button>
                                        </span>
                                    </b-col>
                                </b-row>
                            </div>
                            <div v-else>
                                <p>No activities found.</p>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
            <div class="row" v-else>
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="loader-box">
                                <div class="loader-10"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <!-- Container-fluid Ends-->
    </div>

</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Multiselect from 'vue-multiselect';
import Datepicker from 'vuejs-datepicker';
import moment from "moment";
import NotificationPermission from './notification-permission.vue';
export default {
    components: {
        Multiselect,
        Datepicker,
        NotificationPermission
    },

    data() {
        return {

            start_date: null,
            end_date: null,
            selectedCategory: '',
            filterShow: false,
            categories: [{
                    id: 1,
                    name: "Leave",
                    value: "LEAVE",
                },
                {
                    id: 2,
                    name: "Ticket",
                    value: "TICKET",
                },
                {
                    id: 3,
                    name: "Budget",
                    value: "BUDGET",
                },

                {
                    id: 4,
                    name: "EOD",
                    value: "EOD",
                },
                {
                    id: 5,
                    name: "Requisition",
                    value: "REQUISITION",
                },
                {
                    id: 6,
                    name: "Grievance",
                    value: "GRIEVANCE",
                },

            ],

            updatedTime: null,
            visibleMyUpdates: 15,

            messageRead: null,
            messageBool: false,

            filter: null,

            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            pageOptions: [25, 50, 100],
            loadingPage: false,
            initialLoad: true,
            pageInput: 1,
            pageInputDebounce: null, // Add debounce timer
        };
    },

    watch: {
        start_date(newVal, oldVal) {
            if (this.start_date !== null) {
                this.start_date = moment(String(this.start_date)).format("YYYY-MM-DD");
            }
            if (!this.initialLoad) {
                this.currentPage = 1;
                this.pageInput = 1;
                this.updateRouteQuery();
                this.fetchData();
            }
        },

        end_date(newVal, oldVal) {
            if (this.end_date !== null) {
                this.end_date = moment(String(this.end_date)).format("YYYY-MM-DD");
            }
            if (!this.initialLoad) {
                this.currentPage = 1;
                this.pageInput = 1;
                this.updateRouteQuery();
                this.fetchData();
            }
        },

        messageBool(newVal, oldVal) {
            if (!this.initialLoad) {
                this.currentPage = 1;
                this.pageInput = 1;
                this.updateRouteQuery();
                this.fetchData();
            }
        },

        selectedCategory(newVal, oldVal) {
            if (!this.initialLoad) {
                this.currentPage = 1;
                this.pageInput = 1;
                this.updateRouteQuery();
                this.fetchData();
            }
        },

        currentPage(newVal, oldVal) {

            if (this.pageInput != newVal) {
                this.pageInput = newVal;
            }

            if (!this.loadingPage && !this.initialLoad) {
                this.updateRouteQuery();
                this.fetchData();
            }
        },

        perPage(newVal, oldVal) {
            if (!this.initialLoad) {
                this.currentPage = 1;
                this.pageInput = 1;
                this.updateRouteQuery();
                this.fetchData();
            }
        },

        updates_list(newValue, oldValue) {

        }
    },

    computed: {

        ...mapState({
            updates_list: state => state.myUpdates.my_updates,
            count: state => state.myUpdates.update_count,
            loading: state => state.myUpdates.submitLoading,
            error: state => state.myUpdates.submitError,

        }),
        formattedOptions() {
            return [{
                    value: '',
                    text: 'Select Category',
                    disabled: true
                },
                ...this.categories.map(status => ({
                    value: status.value,
                    text: status.name
                }))
            ];
        },
        readMessage() {
            if (this.messageBool) {
                return 'Only show read'
            } else {
                return 'Only show unread'
            }
        },
        totalPages() {
            return Math.ceil(this.count / this.perPage);
        },

    },

    mounted() {
        // Read parameters from URL query
        const query = this.$route.query;

        // Set pagination

        this.currentPage = parseInt(query.page) || 1;
        this.pageInput = this.currentPage; // Initialize pageInput
        this.perPage = parseInt(query.perPage) || 25;

        // Set filters from query
        if (query.start_date) {
            this.start_date = query.start_date;
        }
        if (query.end_date) {
            this.end_date = query.end_date;
        }
        if (query.category) {
            this.selectedCategory = query.category;
        }
        if (query.unread === 'true') {
            this.messageBool = true;
        }

        // Show filter section if any filter is active
        if (this.start_date || this.end_date || this.selectedCategory) {
            this.filterShow = true;
        }

        // Update URL with all parameters and fetch data
        this.updateRouteQuery();
        this.fetchInitialUpdate();
    },
    beforeDestroy() {

        if (this.pageInputDebounce) {
            clearTimeout(this.pageInputDebounce);
        }
    },

    methods: {
        updateRouteQuery() {
            const query = {
                page: this.currentPage,
                perPage: this.perPage
            };

            if (this.start_date) {
                query.start_date = this.start_date;
            }
            if (this.end_date) {
                query.end_date = this.end_date;
            }
            if (this.selectedCategory) {
                query.category = this.selectedCategory;
            }
            if (this.messageBool) {
                query.unread = this.messageBool;
            }

            if (JSON.stringify(this.$route.query) !== JSON.stringify(query)) {
                this.$router.replace({
                    path: this.$route.path,
                    query
                }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });
            }
        },

        fetchInitialUpdate() {
            this.$store.dispatch("myUpdates/fetchMyUpdates", {
                perPage: this.perPage,
                currentPage: this.currentPage,
                start_date: this.start_date,
                end_date: this.end_date,
                ref_type: this.selectedCategory,
                status: this.messageBool
            }).then(() => {
                this.totalRows = this.count;
                this.initialLoad = false;
            });
        },

        fetchData() {
            if (!this.initialLoad) {
                this.$store.dispatch("myUpdates/fetchMyUpdates", {
                    perPage: this.perPage,
                    currentPage: this.currentPage,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    ref_type: this.selectedCategory,
                    status: this.messageBool
                }).then(() => {
                    this.totalRows = this.count;
                });
            }
        },

        handlePageInput() {

            if (this.pageInputDebounce) {
                clearTimeout(this.pageInputDebounce);
            }

            if (!this.pageInput || this.pageInput === '') {
                return;
            }

            this.pageInputDebounce = setTimeout(() => {
                this.validatePage();
            }, 800);
        },

        validatePage() {
            this.loadingPage = true;

            // Clear debounce timer
            if (this.pageInputDebounce) {
                clearTimeout(this.pageInputDebounce);
                this.pageInputDebounce = null;
            }

            const totalPages = this.totalPages;
            let page = parseInt(this.pageInput);

            if (!page || isNaN(page) || page < 1) {
                page = 1;
            } else if (page > totalPages) {
                page = totalPages;
            }

            this.pageInput = page;
            this.currentPage = page;

            this.loadingPage = false;
        },

        goToPage(page) {
            if (page < 1 || page > this.totalPages) return;
            this.currentPage = page;
            this.pageInput = page; // Update input too
        },
        clearFilter() {
            this.filterShow = false;
            this.start_date = null;
            this.end_date = null;
            this.selectedCategory = '';
            this.currentPage = 1;
            this.updateRouteQuery();
            this.fetchData();
        },

        toggleFilterShow() {
            this.filterShow = !this.filterShow;
        },

        toggleShowMessage() {
            this.messageBool = !this.messageBool;
        },
        updateTime(timestamp) {
            const date = new Date(timestamp);
            const formattedDate = `${date.getDate().toString().padStart(2, '0')}-${
            (date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()}`;

            // Format time as HH:MM:SS AM/PM
            let hours = date.getHours();
            const minutes = date.getMinutes();
            const seconds = date.getSeconds();
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            hours = hours ? hours : 12;

            const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')} ${ampm}`;

            return `${formattedDate } ${formattedTime}`;
        },

        readMsg(data) {
            const routes = {
                'LEAVE': `/my-workspace/leave-details/${data.type_id}`,
                'TICKET': `/ticket/ticket-details/${data.type_id}`,
                'BUDGET': `/my-workspace/budget-details/${data.type_id}`,
                'GRIEVANCE': `/my-workspace/grievance-details/${data.type_id}`,
                'EOD': `/eod/details/${data.type_id}`,
                'REQUISITION': `/my-workspace/requisition-details/${data.type_id}`
            };

            this.$store.dispatch("myUpdates/readMyUpdates", data.id).then(response => {
                if (response.code == 200) {
                    this.$router.push(routes[data.ref_type]);
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            });
        },

    }
};
</script>

<style scoped>
.read {
    background-color: #fff0f0c7;
}

</style>
